import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import App from "./App";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { initObservability } from "@/lib/observability";
import "./styles/index.css";

// Start error tracking before the first render so a crash during boot is
// still reported. Fire-and-forget: nothing below waits on it.
void initObservability();

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root in index.html");

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);

// Native splash stays up during JS boot (launchAutoHide:false in the Capacitor
// config) so the user never sees the blank/laggy gap between the native launch
// screen and the app; hide it after the first paint. The timeout is a safety
// net so it can never get stuck.
if (Capacitor.isNativePlatform()) {
  // Tag the root so native-only CSS applies on device but never on web — both a
  // generic `capacitor` class and the specific platform (`android` / `ios`), so
  // CSS can target one platform (the Android top bar needs a status-bar offset
  // that iOS, with its inset web view, does not).
  document.documentElement.classList.add("capacitor", Capacitor.getPlatform());
  const hideSplash = () => { void SplashScreen.hide(); };
  requestAnimationFrame(() => requestAnimationFrame(hideSplash));
  setTimeout(hideSplash, 3000);
}
